<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Lançamento de BPA consolidado"
    >
        <List
            v-if="layout === 'list'"
            :model="model"
            @edit="handleEdit"
        />

        <Form
            v-else
            :id="id"
            :origem="origem"
            @save="handleExit"
            ref="Form"
        />

        <template v-slot:footer>
            <rkm-button
                v-if="layout === 'list'"
                :disabled="!!loading"
                @click="handleExit"
                color="secondary"
            >
                Fechar
            </rkm-button>

            <rkm-button
                v-else
                :disabled="!!loading"
                @click="layout = 'list'"
                color="secondary"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                v-if="layout === 'form'"
                :disabled="!!loading"
                @click="$refs.Form.save()"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'
import List from './List'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form, List },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        id: null,
        layout: 'list',
        model: {},
        origem: null,
    }),
    methods: {
        open(item) {
            this.id = null
            this.layout = 'list'
            this.model = {}
            this.origem = null

            this.model = Object.assign(item)
            this.$refs.RkmModal.show()
        },
        handleEdit(item) {
            this.id = item.id
            this.layout = 'form'
            this.origem = item.origem
        },
        handleExit() {
            this.$emit('close')
            this.$refs.RkmModal.hide()
        }
    },
}
</script>